import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { __ } from "services/Translator";

export default function InteracResult(props) {
  const params = useParams();
  const [res, setRes] = useState(params.res);
  return (
    <>
      <div style={{ color: "#fff", textAlign: "center" }}>
        {res == "success" && __("Successfully Deposited.")}
        {res == "failure" && __("Deposit Failed.")}
      </div>
    </>
  );
}
